import { Routes, Route, useNavigate } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import { GameProvider } from "./components/header/GameContext";
import HintOverlay from "./components/header/HintOverlay";
//Compornts
import Intro from "./components/intro/imgButton";
import ChatBox from "./components/chat/chat";
import LoginName from "./components/login/loginOne";
import Tutorial from "./components/tutorial/tutorial";
import Quize from "./components/quize/quize";
import Keyword from "./components/keywordInput/keyword";
import Answer from "./components/answer/answer";
import Clear from "./components/clear/clear";

//test

import PersonComponent from "./PersonComponent.js";

import ScrollTotop from "./scrollToTop";
//CSS
import "./index.css";

//IMG import
import tutorial1 from "./img/tutorial/tutorial-1.png";
import tutorial2 from "./img/tutorial/tutorial-2.png";
import tutorial3 from "./img/tutorial/tutorial-3.png";

export default function App() {
  const navigate = useNavigate();
  const [nameText, setNameText] = useState("");

  return (
    <GameProvider>
      <ScrollTotop />
      <HintOverlay />
      <Routes>
        {/* <Route path="/" element={<PersonComponent />} /> */}
        <Route
          path="/"
          element={<Intro onFinish={() => navigate("/login")} />}
        />
        <Route
          path="/login"
          element={
            <LoginName
              handleName={nameText}
              setHandleName={setNameText}
              onFinish={() => navigate("/story")}
            />
          }
        />
        <Route
          path="/story"
          element={
            <ChatBox
              DateVal={"DATA1"}
              titImgClass={"infoTit"}
              onFinish={() => navigate("/tutorial")}
              timerMode="pause"
            />
          }
        />
        <Route
          path="/tutorial"
          element={
            <Tutorial
              tutorialImgs={[tutorial1, tutorial2, tutorial3]}
              onFinish={() => navigate("/story2")}
              timerMode="pause"
            />
          }
        />
        <Route
          path="/story2"
          element={
            <ChatBox
              DateVal={"DATA2"}
              titImgClass={"infoTit2"}
              onFinish={() => navigate("/keywordInput")}
              timerMode="pause"
            />
          }
        />
        <Route
          path="/keywordInput"
          element={
            <Keyword
              answerData={"keyword"}
              DateVal={"DATA3"}
              titImgclassName={"infoTit"}
              hintWhetherIs={false}
              hintContent={""}
              timerMode="run"
            />
          }
        />
        <Route path="/quiz" element={<Quize />} />
        <Route
          path="/answer"
          element={<Answer DateVal={"DATA2"} titImgclassName={"infoTit"} />}
        />
        <Route path="/clear" element={<Clear />} timerMode="pause" />
        {/* <Route
          path="/chat"
          element={<ChatBox DateVal="DATA1" titImgClass="infoTit" />}
        />
        <Route path="/content" element={<Tutorial />} /> */}
      </Routes>
    </GameProvider>
  );
}

//  <Quize
//    answerData={"keyword"}
//    DateVal={"DATA3"}
//    titImgclassName={"infoTit"}
//    hintWhetherIs={false}
//    hintContent={""}
//  />;
